/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.jquery = function jquery($window) {
        return $window.$;
    };

}());
